var Sushi;

var setupNewIssuesChildTables;

(function (Sushi) {
	"use strict";

	/** @type {HTMLFormElement} */
	var form = document.querySelector("[data-feature=newIssuesFilter]");

	if (!form) {
		return;
	}

	/** @type {HTMLSelectElement} */
	var issuerGroupInput = form.querySelector("[data-input=issuerGroup]");

	/** @type {HTMLSelectElement} */
	var assetTypeInput = form.querySelector("[data-input=assetType]");

	Sushi.Events(issuerGroupInput).on("Select.change", function () {
		// reset select value
		if (assetTypeInput.value) {
			assetTypeInput.value = "";
			Sushi.Events(assetTypeInput).trigger("Select.change");
		}

		Sushi.Util.removeSelectOptions(assetTypeInput);

		// add options to select
		var opt, optList;

		if (issuerGroupInput.value === "C") {
			optList = [
				{ value: "1", label: "All Types" },
				{ value: "2", label: "Corporate Debt" },
				{ value: "3", label: "Corporate Equity" },
				{ value: "4", label: "All Corporate" },
				{ value: "5", label: "IPOs" },
				{ value: "6", label: "Mutual Funds" },
				{ value: "7", label: "Municipals" },
				{ value: "8", label: "Certificate of Deposit" },
			];
		}
		else {
			optList = [
				{ value: "1", label: "All Types" },
			];
		}

		for (var j = 0, n = optList.length; j < n; j++) {
			/** @type {HTMLOptionElement} */
			opt = document.createElement("option");
			opt.value = optList[j].value;
			opt.text = optList[j].label;
			assetTypeInput.add(opt);
		}

		Sushi.Events(assetTypeInput).trigger("change");
	});

	var table = $("#newIssuesTable").DataTable();
	var reloadInterval = 5000;
	var reloadButton = form.querySelector("[data-reload-new-issues]");
	var lastReload = Date.now();

	reloadButton.addEventListener("click", function () {
		var timeSinceLastReload = Date.now() - lastReload;

		if (timeSinceLastReload > reloadInterval) {
			Sushi.Util.animate(reloadButton.querySelector(".c-btn__icon"), "rotate-clockwise");
			table.ajax.reload(setupNewIssuesChildTables);
			lastReload = Date.now();

			return;
		}

		var secondsLeft = ((reloadInterval - timeSinceLastReload) / 1000).toFixed(0);

		alert("Please wait " + secondsLeft + " seconds to refresh data again!");
	});

})(Sushi || (Sushi = {}));
